import { RuleType } from '@asta/core'
import type { RunDto } from '@asta/repository-client-axios'

import type { AnalyticsDTO } from '@/api/repository/repositorySchemas'

export const ruleTypeToLabel = {
	[RuleType.Accessibility]: 'Accessibility',
	[RuleType.Resource]: 'Resources',
	[RuleType.Functional]: 'Functionality',
	[RuleType.Webform]: 'Webform',
	[RuleType.Link]: 'Link',
	[RuleType.Spellcheck]: 'Spelling',
	[RuleType.Performance]: 'Performance',
	[RuleType.Readability]: 'Readability',
	[RuleType.Security]: 'Security',
	Flow: 'Flows',
}

// sums up the identical key numeric values in an array of objects
// the key: groupBy, a prop to skip: skipProp
export const groupBy = (arr: AnalyticsDTO[]): AnalyticsDTO[] => {
	const groupBy = 'ruleType'
	const skipProp = 'runId'

	return Object.values(
		arr.reduce((acc, obj) => {
			const key = obj[groupBy]
			if (!acc[key]) {
				acc[key] = {}
			}
			for (const prop in obj) {
				if (prop === groupBy || prop === skipProp) {
					// don't sum up the values of the grouping key or the skipped prop
					continue
				}
				acc[key][prop] = (acc[key][prop] || 0) + obj[prop]
			}

			return acc
		}, {})
	)
}

// removes duplicates in a string array
export const getUniqueItemsArray = (arr: string[]): string[] => {
	const seen = {}

	return arr.filter(item => {
		return Object.prototype.hasOwnProperty.call(seen, item)
			? false
			: (seen[item] = true)
	})
}

export const getBreadcrumbItem = (
	run: RunDto,
	variantId: string
): { id: string; displayText: string; url: string } => {
	return {
		id: 'runNumber',
		displayText: `Run #${run.runNumber}`,
		url: `/app/${variantId}/dashboard?run=${run._id}&view=Dashboard`,
	}
}
